/* eslint-disable react/prop-types */
import { FaXmark } from "react-icons/fa6";
import BillingPage from "./billingPage";
import ConvertOrder from "./convertOrder";
import { useDispatch, useSelector } from "react-redux";
import { setNoteData, setOrderData, setPreOrderDateAndTimeData, updateOrderType } from "@/redux/slice/take-order-slice/order-slice";
import { resetSelectedCustomer, setSelectedCustomer } from "@/redux/slice/take-order-slice/selected-customer-slice";
import { setCart } from "@/redux/slice/take-order-slice/cart-slice";
import { setDeliveryInfo } from "@/redux/slice/take-order-slice/delivery-slice";
import BackendToCartDataFormat from "@/lib/BackendToCartDataFormat";
import { AlarmClock } from "lucide-react";
import { setReduxFormatDateTime } from "@/lib/dateTimeConversion";
import toast from "react-hot-toast";
import { useState, useEffect } from "react";
import { TableIcon } from "./Icons";
import { complementaryItemsApi } from "@/api/take-order/take-order";
import { getOrderCustomerName, getOrderCustomerPhone } from "@/lib/utils";

function Complementary({setComplementaryPage}) {
    const [isTabletView, setIsTabletView] = useState(window.innerWidth <= 1200);
    const [items, setItems] = useState([]);
    const dispatch = useDispatch();

    useEffect(() => {
        const handleResize = () => {
            setIsTabletView(window.innerWidth <= 1200);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    const { orderData:order } = useSelector((state) => state.takeOrder.order);
    const isCompleted = order?.stage === "completed";
        

    const saveComplementary = async () => {
        complementaryItemsApi(order?.id, {items: items})
        .then((response) => {
            if (response.status === "success") {
                toast.success("Complementary items saved successfully.");
                dispatch(setOrderData(response.data));
                setComplementaryPage(false);
            } else {
                toast.error(response.message || "Failed to save complementary items.");
            }
        })
        .catch((error) => {
            toast.error("An error occurred while saving complementary items.");
        });
    }


    function toggleItem(itemId) {
        return () => {
            setItems(prevItems => {
                const exists = prevItems.some(item => item.id === itemId);
                if (!exists) {
                    return [...prevItems, { id: itemId, is_complementary: true }];
                }
                return prevItems.map(item =>
                    item.id === itemId ? { ...item, is_complementary: !item.is_complementary } : item
                );
            });
        };
    }

    function isItemSelected(itemId) {
        return items.some(item => item.id === itemId && item.is_complementary === true);
    }

    useEffect(() => {
        if (order?.items) {
            console.log("order items:", order.items);
            const complementaryItems = order.items.map(item => ({ id: item.order_item_id, is_complementary: item?.is_complementary || false }));
            setItems(complementaryItems);
        }
    }, [order?.items]);
        
    console.log("complementary items:", items);


  return (
    <div className={`${isTabletView ? "w-[500px] h-[630px]" : "w-[600px] h-[660px]"} bg-color2 ${isTabletView ? "p-4" : "p-6"} rounded-md border-4 border-color3 relative`}>
        <button onClick={()=> { setComplementaryPage(false) }} className={`absolute top-0 right-0 text-color8 float-right ${isTabletView ? "text-xl" : "text-2xl"} p-2`}><FaXmark/></button>
        <h1 className={`${isTabletView ? "-mt-3 text-xl" : "-mt-4 text-2xl"} text-center font-semibold`}>Complementary </h1>
            {
                isCompleted && (
                    <h1 className={`font-bold ${isTabletView ? "mb-1 text-sm" : "mb-2 text-base"} uppercase text-color7 text-center`}> (Completed)</h1>
                )
            }
        <h2 className={` mt-2 -mb-2 flex items-center justify-center gap-4 text-color6 text-center ${isTabletView ? "text-xs" : "text-sm"}`}> (#{order?.day_order_number})
            {order?.reservation?.table?.name && (
                <div className="flex items-center gap-1">
                    <span><TableIcon className="w-4 h-4 stroke-color6" /></span>
                    <span className="text-color6">{order?.reservation?.table?.name}</span>
                </div>
            )}
        </h2>
        {
            order?.pre_order_date_and_time && order.stage == "pre_order" &&
            <div className={`text-color7 font-semibold flex items-center ${isTabletView ? "gap-0.5 text-xs mt-0.5" : "gap-1 mt-1"}`}>
                    <AlarmClock className={`stroke-color7 ${isTabletView ? "w-4 h-4" : "w-5 h-5"}`} /> 
                    <span>{ new Date(order?.pre_order_date_and_time).toLocaleString()}</span>
            </div>
        }
       <div className={`w-full h-full ${isTabletView ? "mt-3" : "mt-5"}`}>
            <div className={`w-full bg-color3 ${isTabletView ? "p-1.5" : "p-3"} grid grid-cols-2 gap-x-6 gap-y-2 rounded-sm`}>
                <div className={`flex flex-col ${isTabletView ? "gap-1 text-xs" : "gap-2"} min-w-0`}>
                    <div className="flex items-center gap-2 min-w-0">
                        <div className={`${isTabletView ? "w-[75px]" : "w-[90px]"} font-semibold shrink-0`}>Order ID:</div> 
                        <span className="text-color6 truncate">{ order?.id}</span>
                    </div>
                    <div className="flex items-center gap-2 min-w-0">
                        <div className={`${isTabletView ? "w-[75px]" : "w-[90px]"} font-semibold shrink-0`}>Customer:</div>
                        <span className="text-color6 truncate" title={getOrderCustomerName(order, "Unknown")}>{getOrderCustomerName(order, "Unknown")}</span>
                    </div>
                    <div className="flex items-center gap-2 min-w-0">
                        <div className={`${isTabletView ? "w-[75px]" : "w-[90px]"} font-semibold shrink-0`}>Phone:</div>
                        <span className="text-color6 truncate">{getOrderCustomerPhone(order, "-")}</span>
                    </div>
                </div>
                <div className={`flex flex-col ${isTabletView ? "gap-1 text-xs" : "gap-2"} min-w-0`}>
                    <div className="flex items-center gap-2 min-w-0">
                        <div className={`${isTabletView ? "w-[85px]" : "w-[95px]"} font-semibold shrink-0`}>Type:</div>
                        <span className="text-color6 truncate">{(order?.order_type == "pickup")? "Pickup" : (order?.order_type == "delivery")? "Delivery" :  (order?.order_type == "in_house")? "In House" :  (order?.order_type == "table")? "Table" : "" }</span>
                    </div>
                    <div className="flex items-center gap-2 min-w-0">
                        <div className={`${isTabletView ? "w-[85px]" : "w-[95px]"} font-semibold shrink-0`}>Date:</div>
                        <span className="text-color6 break-words">{new Date(order?.created_at).toLocaleDateString()}</span>
                    </div>
                    <div className="flex items-center gap-2 min-w-0">
                        <div className={`${isTabletView ? "w-[85px]" : "w-[95px]"} font-semibold shrink-0`}>Tracking ID:</div>
                        <span className="text-color6 truncate">{order?.day_order_number}</span>
                    </div>
                </div>
            </div>
            <div className={`${isTabletView ? "mt-1.5" : "mt-2"}`}>
                <h2 className={`font-semibold py-2 mt-4 ${isTabletView ? "text-sm" : "text-base"}`}>Select Complementary Items</h2>
                <div className={`${isTabletView ? "h-[180px]" : "h-[330px]"} overflow-auto`}>
                    {
                        order.items.map((item, index) => (
                            <div onClick={toggleItem(item?.order_item_id)} key={index} className={`${isTabletView ? "mb-1.5 p-1 text-xs gap-2" : "mb-2 p-2 gap-4"} bg-color3 flex`}>
                                <input readOnly type="checkbox" name={ item?.order_item_id} id={ item?.order_item_id} checked={isItemSelected(item?.order_item_id)} className=" w-5 h-5 accent-yellow-500" />
                                <div className={`${isTabletView ? "w-[150px]" : "w-[220px]"}`}>
                                    <span>{item.name}</span>
                                </div>
                                <div className={`${isTabletView ? "w-[80px]" : "w-[120px]"}`}>
                                    {
                                        item?.variant?.name && <span className="text-color6">({item?.variant?.name})</span>
                                    }
                                    {
                                        item?.size && <span className="text-color6">({item?.size})</span>
                                    }
                                    {
                                        item.buffet_price_for && <span className="text-color6">({item.buffet_price_for == "adult" ? "Adult" : "Kids"})</span>
                                    }
                                </div>
                                <div>
                                    <span className="text-color6">x{item.quantity}</span>
                                </div>
                                <div className=" grow text-right">
                                    { item?.price && <span className=" text-color6">£{item.price}</span>}
                                    { item?.variant?.price && <span className=" text-color6">£{item?.variant?.price}</span>}

                                    {item.buffet_price_for == "adult" ? 
                                        (
                                            <>{ item?.adult_price  && <span className=" text-color6">£{item?.adult_price}</span>}</>
                                        ) :
                                        (
                                            <>{ item?.kids_price && <span className=" text-color6">£{item?.kids_price}</span>}</>
                                        )
                                    }
                                        
                                   

                                    {order?.order_type === "in_house" || order?.order_type === "table" ? 
                                        (
                                            <>
                                                { item?.in_price && <span className=" text-color6">£{item.in_price}</span>}
                                                { item?.variant?.in_price && <span className=" text-color6">£{item?.variant?.in_price}</span>}
                                            </>
                                        ) : 
                                        (
                                            <>
                                                { item?.out_price && <span className=" text-color6">£{item.out_price}</span>}
                                                { item?.variant?.out_price && <span className=" text-color6">£{item?.variant?.out_price}</span>}
                                            </>
                                        )
                                    }
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>

            <div className={`${isTabletView ? "mt-2 gap-1.5" : "mt-4 gap-2"} flex flex-col`}>
                <div className={`flex ${isTabletView ? "gap-1.5" : "gap-2"}`}>
                    <button onClick={()=> { saveComplementary(); }} className={`w-full ${isTabletView ? "p-1.5 text-xs" : "p-2 text-sm"} bg-color7 font-bold rounded-md flex flex-col items-center justify-center gap-0.5`}>
                        <span>Confirm</span>
                    </button>
                </div>
            </div>
      </div>
    </div>
  );
}
export default Complementary;